import React from 'react';
import type { LegacyFieldLayoutApp } from '@atlassian/jira-admin-pages-legacy-field-layout/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyLegacyFieldLayoutPromise = lazyForPaint<typeof LegacyFieldLayoutApp>(() => {
	return markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-pages-legacy-field-layout", jiraSpaEntry: "async-admin-pages-legacy-field-layout" */ '@atlassian/jira-admin-pages-legacy-field-layout'
		).then((bundle) => bundle.LegacyFieldLayoutApp),
	);
});

export const LazyLegacyFieldLayoutPage = () => (
	<LazyPage
		Page={LazyLegacyFieldLayoutPromise}
		pageId="jira-admin-pages-legacy-field-layout"
		shouldShowSpinner
	/>
);
